import {
  ModalContext,
  PaginationContext,
  PropertyHistoryModal,
  ViewerContext,
} from "dash-ui";
import { useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useMemo } from "react";

import { RoutesPath } from "flow-components/routes/routes";
import { useGetPortfolioPropertiesChangelogsQuery } from "gql/generated.graphql";

const PropertyUpdatesModal = () => {
  const theme = useTheme();
  const {
    isOpenCurrent,
    toggleModal,
    payload = {},
    setPayload,
  } = useContext(ModalContext);
  const { broker } = useContext(ViewerContext);
  const navigate = useNavigate();
  const isOpen = isOpenCurrent["PropertyUpdatesModal"];
  const { t } = useTranslation("pages", {
    keyPrefix: "dashboardPage.propertyUpdatesWidget",
  });
  const { setTotal, state, resetPagination, getRefetchProps } =
    useContext(PaginationContext);
  const pagination = getRefetchProps(state);
  const variables = useMemo(
    () => ({
      pagination,
      filter: { dateRange: payload.range },
      sort: [{ fieldName: "createdAt", sortOrder: -1 }],
    }),
    [pagination, payload.range]
  );

  const { data, loading } = useGetPortfolioPropertiesChangelogsQuery({
    variables,
    fetchPolicy: "network-only",
    skip: !broker,
  });

  const { propertiesChangelogs, totalCount } = useMemo(
    () => ({
      propertiesChangelogs:
        data?.getPortfolioPropertiesChangelogs.collection || [],
      totalCount: data?.getPortfolioPropertiesChangelogs.totalCount || 0,
    }),
    [data]
  );

  useEffect(() => {
    // FIXME: re-creating context functions everytime state change. Use useCallback
    setTotal(totalCount);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalCount]);

  const closeModal = () => {
    toggleModal(false, "PropertyUpdatesModal");
    setPayload({});
    resetPagination();
  };

  return (
    <PropertyHistoryModal
      isOpen={isOpen}
      loading={loading}
      placeholder={t("noPropertyUpdatesPlaceholder") || ""}
      variation="secondary"
      onClose={() => closeModal()}
      onRowClick={(propertyId) =>
        navigate(RoutesPath.PropertyPreview.replace(":id", propertyId))
      }
      data={propertiesChangelogs}
      datePeriodPickerProps={{
        ml: 3,
        color: theme.colors.n80,
        defaultType: payload.type,
        anchorTextProps: { md: true },
        onChange: (range, type) => setPayload({ range, type }),
      }}
    />
  );
};

export default PropertyUpdatesModal;
